import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/theme.css';
import './index.css';
import './styles/responsive.css';
import './styles/dark-theme-overrides.css';
import { initTheme } from './utils/theme';
import App from './App';
import reportWebVitals from './reportWebVitals';

initTheme();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);

reportWebVitals();
